import React from 'react';
import routeConstant from '../../lib/constants/routeConstant';
import AuthenticationLayout from '../../components/AuthenticationLayout/AuthenticationLayout';
import ResetPasswordForm from '../../components/ResetPassword/ResetPasswordForm';


/*  Options object to determine the visibility and properties of the navigation button in the authentication layout. */
const options = {
  showButton: true,
  navUrl: routeConstant.LOGIN_PAGE,
  buttonName: "Login",
  heading: "Reset Password",
  subHeading: "Reset Your Password Here"
}

const ResetPasswordPage = () => {
  return (
     /* Render the AuthenticationLayout component as a wrapper around the CreatePasswordForm. Pass the options object 
     to control the layout's property */
    <AuthenticationLayout options={options}>
      <ResetPasswordForm />
    </AuthenticationLayout>
  )
}

export default ResetPasswordPage